import { createSlice } from "@reduxjs/toolkit";

const addNewParentSlice = createSlice({
    name: "addNewParentSetup",
    initialState: {
        newParentData: null,
        ParentDeviceQRCode: null,
        addParentStatus: ''
    },
    reducers: {
      setNewParentData: (state, action) => {
        state.newParentData = action?.payload
      },
      setAddParentStatus: (state, action) => {
        state.addParentStatus = action?.payload
      },
      setParentDeviceData: (state, action) => {
        state.ParentDeviceQRCode = action?.payload
      },
      removeNewParentData: (state, action) => {
        state.newParentData = null
        state.ParentDeviceQRCode = null
        state.addParentStatus = ''
      },
      clearAddNewParent: (state, action) => {
        state.newParentData = null
        state.ParentDeviceQRCode = null
        state.addParentStatus = ''
      }
    }
  });


// this is for dispatch
export const { setNewParentData, removeNewParentData, setAddParentStatus, setParentDeviceData, clearAddNewParent } = addNewParentSlice.actions;

// this is for configureStore
export default addNewParentSlice.reducer;